import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Lottie from "react-lottie";

import loadingJson from "bodycodi/cmap/app/json/loading.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingJson,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function LoadingWrap({ loading }) {
  return ReactDOM.createPortal(<Loading loading={loading} />, document.getElementById("root"));
}

function Loading({ loading }) {
  const [isStopped, setIsStopped] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  return (
    <React.Fragment>
      {loading && (
        <div className="loading-bpay-pop">
          <div className="loading-bpay">
            <Lottie options={defaultOptions} isStopped={isStopped} isPaused={isPaused} />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default LoadingWrap;
